import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M18 20V6a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v14", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M2 20h20", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M14 12v.01", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "DoorClosed";
const DoorClosed = memo(themed(Icon));
export {
  DoorClosed
};
//# sourceMappingURL=door-closed.js.map
